import './style.scss';

const LandingWithoutLogin = () => {};

export default LandingWithoutLogin;
